module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anna Dean\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("ANNA DEAN began writing early on under the impression that everyone was taught to do so in order to pen books. By the time she discovered her mistake, the habit was too deeply ingrained to give up. She lives in England.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4gNMfX/tc-custom/9781429942560.jpg?1725275587343",
      "alt": "This image is the cover for the book Woman of Consequence, Dido Kent Investigations"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Woman of Consequence, Dido Kent Investigations\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A clever Regency sleuth” investigates a supposedly haunted abbey—and a decidedly suspicious death—in this “excellent mystery” ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(", starred review).")]), _c('br'), _c('br'), _c('i', [_vm._v("England, 1806")]), _vm._v(". With a downturn in family finances, Miss Dido Kent is compelled to reside at her brother’s country vicarage. But the rural environs offer plenty of stimulation, especially when her friend Penelope suffers a fall at a historic abbey. Before she slips into unconsciousness, Penelope proclaims, ‘I saw her—It was her.’ Soon people are certain that she saw the Grey Nun, a ghost reputed to walk the abbey’s ruins."), _c('br'), _c('br'), _vm._v("Dido, however, does not approve of ghosts. Disregarding the chatter, she resolves to investigate the mystery. But the case turns sinister when a human skeleton is found in the abbey lake. Could the discovery be connected to Penelope’s accident? Everyone is relying on Dido to find out.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0